import { TestConfig } from "yup/lib/util/createValidation";

export const getOptionalMinLengthTest = (
  minLength: number,
  errorMessage?: string
): TestConfig<string | undefined> => {
  return {
    name: "minLengthIfNotEmpty",
    message: errorMessage || `Should have at least ${minLength} characters`,
    test: (value: string | undefined, context) =>
      !value || value.trim().length >= minLength
  };
};
